import useAddress from '@/containers/SubscriptionFormPageNew/Components/Address/useAddress'
import SDFormControl from '@/shared/components/SDComponentsNewDesign/SDFormControl/SDFormControl'
import getError from '@/containers/SubscriptionFormPageNew/getError'
import SDInput from '@/shared/components/SDComponentsNewDesign/SDInput/SDInput'

const ApartmentNumber = () => {
  const { t, updateAddress, errors, apartmentNumber, isApartment, showApartmentNumber } = useAddress()

  if (!showApartmentNumber || !isApartment) {
    return null
  }

  return (
    <SDFormControl plainLabel error={getError('apartmentNumber', errors)}>
      <SDInput
        label={t('subscriptionForm:address_module.appartment_number')}
        onBlur={apartmentNumber => updateAddress({ apartmentNumber })}
        currentValue={apartmentNumber}
      />
    </SDFormControl>
  )
}

export default ApartmentNumber
